exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width: 767px){.styles--onlyXs__3Unej{display:none !important}}@media (min-width: 768px){.styles--smUp__1fWxD{display:none !important}}@media (max-width: 999px){.styles--mdDown__2qefR{display:none !important}}.styles--closable__2QpY4{padding-right:40px !important;position:relative}.styles--closableTrigger__rFF2w{padding:8px;position:absolute;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);right:8px;cursor:pointer}.styles--closableTrigger__rFF2w.styles--mobileonly__2gOly{background:rgba(255, 255, 255, .2);z-index:1}.achievementsDialog .styles--closableTrigger__rFF2w{position:fixed;top:40px;right:20px}.styles--title__VWRKo{font-size:16px !important;line-height:22px !important;font-weight:600 !important}.styles--centered__3hhR-{text-align:center}\n", ""]);

// exports
exports.locals = {
	"onlyXs": "styles--onlyXs__3Unej",
	"smUp": "styles--smUp__1fWxD",
	"mdDown": "styles--mdDown__2qefR",
	"closable": "styles--closable__2QpY4",
	"closableTrigger": "styles--closableTrigger__rFF2w",
	"mobileonly": "styles--mobileonly__2gOly",
	"title": "styles--title__VWRKo",
	"centered": "styles--centered__3hhR-"
};